import React from 'react';
import classNames from 'classnames';
import { NetworkCondition } from '../../stores/types/opentok-health';

/**
 * Two different absences, previously both shown as "unknown":
 *
 * - `undefined` - no transport in the report at all, so nothing was measured.
 * - `'unknown'` - the SDK measured and cannot classify yet. Its network
 *   condition comes from a state machine that needs samples to settle, so a
 *   client that just joined legitimately reports this for a while.
 */
export default function ConditionPill({ condition }: { condition?: NetworkCondition }) {
	if (!condition) {
		return <span className='health-net health-net--unmeasured'>not measured</span>;
	}

	return (
		<span className={classNames('health-net', `health-net--${condition}`)}>
			{condition}
		</span>
	);
}
